import React, { useEffect } from 'react';

import { colors, layout } from 'Constants';

// State
import { ApiStore } from 'Store';
import { Subscribe } from 'laco-react';

import { Container, Header, Anchor, Button } from 'Components/core';

// Icons
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-solid-svg-icons';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';
import PaddedContainer from 'Components/core/PaddedContainer';
import styled from 'styled-components';

const correctURL = url => {
  if (url.includes('https://') || url.includes('http://')) {
    return url;
  }
  return 'https://' + url;
};

const CustomList = styled.ol`
  list-style-type: none;
  padding-left: 0;
`;

const ListItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
`;

const Bullet = styled.span`
  background-color: #1e88e5; /* Blue background color */
  color: white; /* White text color */
  display: inline-block;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  text-align: center;
  line-height: 24px;
  font-weight: bold;
  flex-shrink: 0;
  margin-right: 10px;
`;

const Content = styled.div`
  flex-grow: 1;
`;

const Para = styled.p`
  font-family: 'Elevance Sans Regular';
  font-weight: normal;
  font-size: 18px;
  font-size: 18px;
  line-height: 26px;
  text-align: left;
  color: #131331;
  margin-top: 20px;
  margin-bottom: 10px;
`;

const BottonContainer = styled(Container)`
  padding: 40px;
  padding-top: 40px;
  padding-bottom: 40px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 40px;
`;

const StepsContainer = styled.div`
  width: 1128px;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 100%;
  }

  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);

  > .inner {
    width: 70%;

    @media screen and (max-width: ${layout.breakpoints.mobile}) {
      width: 90%;
    }
  }

  * > li {
    font-family: 'Elevance Sans Regular';
    font-weight: normal;
    font-size: 18px;
    line-height: 26px;
    text-align: left;
    color: #131331;
    margin-top: 30px;
    margin-bottom: 50px;
    margin-left: 40px;
  }
`;

const StepsHeader = styled.div`
  width: 840px;
  height: 69px;
  border-radius: 0px 8px 8px 0px;
  background: #e1edff;
  padding-left: 60px;
  display: flex;
  align-items: center;
  font-family: 'Elevance Sans Semibold';
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  text-align: left;
  color: #333;
  margin-top: 60px;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 100%;
  }
`;
export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_FIND_PROVIDER);
  }, []);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        if(state?.findProviders?.resource)
        {
          state.findProviders.resource=toArray(state?.findProviders?.resource);
        }

        return (
          <Container column maxWidth style={{ margin: 'auto' }}>
            <HeaderV2 title={'Find a Provider'}></HeaderV2>
            <PaddedContainer seperation={20} style={{ paddingTop: 20 }} column>
              <Para>
                Our Find Care tool is a great way to find care providers in your
                health plan’s network. Even if you haven’t yet enrolled, using
                this tool to see if your current doctors are in the plans’
                networks can help you make the right choice during open
                enrollment and save you money on care.
              </Para>

              <Para>
                Search by the doctor’s name or specialty, type of procedure, and
                for hospitals, pharmacies, and high-quality labs.
              </Para>
              {state?.findProviders && (
                <BottonContainer>
                  {state?.findProviders?.resource?.map((item, index) => {
                    return (
                      <Button to={correctURL(item.url)}> {item.label} </Button>
                    );
                  })}
                </BottonContainer>
              )}

              <Para>
                If you are already an Anthem member, use the Find Care tool
                after logging into anthem.com or the Sydney Health mobile app
                for a personalized search. You will also find other helpful
                tools and resources.
              </Para>
            </PaddedContainer>
            <PaddedContainer>
              <StepsContainer column>
                <StepsHeader>
                  To see if your doctors are in the plan network you can follow
                  the steps below:
                </StepsHeader>
                <div className="inner">
                  <CustomList>
                    <ListItem>
                      <Bullet>1</Bullet>
                      <Content>
                        Go to{' '}
                        <Anchor to="https://anthem.com/find-care">
                          anthem.com/find-care
                        </Anchor>
                      </Content>
                    </ListItem>
                    <ListItem>
                      <Bullet>2</Bullet>
                      <Content>Choose Basic search as a guest</Content>
                    </ListItem>

                    <ListItem>
                      <Bullet>3</Bullet>
                      <Content>
                        Select the type of plan or network — Medical Plan or
                        Network.{' '}
                      </Content>
                    </ListItem>
                    <ListItem>
                      <Bullet>4</Bullet>
                      <Content>
                        Choose the state where the plan or network is located.
                        (Most of the time, it’s where the headquarters is
                        located.){' '}
                      </Content>
                    </ListItem>
                    <ListItem>
                      <Bullet>5</Bullet>
                      <Content>
                        Select how you get health insurance – Medical
                        (Employer-Sponsored){' '}
                      </Content>
                    </ListItem>
                    <ListItem>
                      <Bullet>6</Bullet>
                      <Content>
                        Choose a plan or network —{' '}
                        {state?.findProviders?.resource?.map((item, index) => {
                          return (
                            <>
                              {' '}
                              <Anchor to={correctURL(item.url)}>
                                {' '}
                                {item.label}{' '}
                              </Anchor>{' '}
                              {state?.findProviders?.resource?.length > 1 &&
                                index !=
                                  state?.findProviders?.resource?.length - 1 &&
                                ' or '}{' '}
                            </>
                          );
                        })}
                      </Content>
                    </ListItem>
                    <ListItem>
                      <Bullet>7</Bullet>
                      <Content>Select the Continue button</Content>
                    </ListItem>
                    <ListItem>
                      <Bullet>8</Bullet>
                      <Content>
                        Enter your city, county, or ZIP code. You also can
                        search by doctor, or procedure, as well as using other
                        care-related terms{' '}
                      </Content>
                    </ListItem>
                    <ListItem>
                      <Bullet>9</Bullet>
                      <Content>
                        View your search results. You can filter your results by
                        &gt; selecting the relevant boxes on the left or
                        browsing by list or map views.
                      </Content>
                    </ListItem>
                 
                  <div style={{marginLeft:60,marginBottom:40}}>
 
                    {(state?.includeDental || state?.includeVision) && (
                      <>
                        You can also search {state?.includeDental && ' dental '}{' '}
                        {state?.includeDental &&
                          state?.includeVision &&
                          ' and '}
                        {state?.includeVision && 'vision'} providers. For the
                        type of plan select
                        {state?.includeDental && ' Dental Plan or Network'}{' '}
                        {state?.includeDental && state?.includeVision && ' or '}{' '}
                        {state?.includeVision && ' Vision Plan or Network'} and
                        for the Plan or network{' '}
                        {state?.includeDental && ' for    ' + state?.dental?.dentalPlans?.planDental[0].name}{' '}
                        {state?.includeDental && state?.includeVision && ' or '}{' '}
                        {state?.includeVision && ' for Blue View Vision ' + ''}
                      </>
                    )}
                  </div>
                  </CustomList>
                </div>
              </StepsContainer>
            </PaddedContainer>
          </Container>
        );
      }}
    </Subscribe>
  );
};

function toArray(val) {
  return Array.isArray(val) ? val : val?[val]:[];
}

